<form [formGroup]="form">
    <p-multiSelect #select class="w-full" styleClass="w-full" [options]="sortedOptions()" formControlName="location"
        appendTo="body" [filter]="true" display="chip" filterBy="name" (onChange)="valueChange()"
        (onBlur)="onInputBlur()" [autofocusFilter]="true">
        <ng-template pTemplate="header">
            @if(locationGroupsInternal() && locationGroupsInternal().length > 0) {
            <div class="flex gap-1 flex-wrap p-1">
                @for (group of locationGroupsInternal(); track $index) {
                <div>
                    <p-button size="small" (click)="selectGroup(group)">
                        {{ group.label }}
                    </p-button>
                </div>
                }

            </div>
            }

        </ng-template>
        <ng-template pTemplate="selectedItems">
            @if(!value || value.length === 0) {
            <div class="p-dropdown-label-empty">empty</div>
            }

            @for (option of value; track $index) {
            <p-tag>{{option | locationDisplay}} <fa-icon class="p-tag-icon-right" [icon]="icons.solid.faCircleXmark"
                    (click)="removeItem(option)"></fa-icon></p-tag>
            }

        </ng-template>
        <ng-template let-location pTemplate="item">
            {{location | locationDisplay}}
        </ng-template>

    </p-multiSelect>
</form>